
// ! rename the function to align with the widget name
export const accordian = () => {
    const el = document.querySelector('.curious-accordian');
    if (!el) return;

    // ------------------------------------------------------------
    const accordionTitles = document.querySelectorAll('.accordion-title');
    
    accordionTitles.forEach(function(title) {
        title.addEventListener('click', function() {
            const content = this.nextElementSibling;
            const accordion = this.closest('.custom-accordion-wrapper');
            
            // Close other items in the same accordion
            const otherTitles = accordion.querySelectorAll('.accordion-title.active');
            const otherContents = accordion.querySelectorAll('.accordion-content.active');
            
            otherTitles.forEach(function(otherTitle) {
                if (otherTitle !== title) {
                    otherTitle.classList.remove('active');
                    otherTitle.setAttribute('aria-expanded', 'false');
                }
            });
            
            otherContents.forEach(function(otherContent) {
                if (otherContent !== content) {
                    otherContent.classList.remove('active');
                    otherContent.setAttribute('aria-hidden', 'true');
                }
            });
            
            // Toggle current item
            this.classList.toggle('active');
            content.classList.toggle('active');
            
            // Update aria attributes
            const isExpanded = this.classList.contains('active');
            this.setAttribute('aria-expanded', isExpanded);
            content.setAttribute('aria-hidden', !isExpanded);
        });
    });
   

    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}

